'use client';

import { Toaster } from 'sonner';
import { useTheme } from 'next-themes';

/**
 * sonner-Toaster, an next-themes gekoppelt — folgt System UND manuellem Override.
 * (Standalone <Toaster theme="system"/> würde den manuellen Override ignorieren.)
 */
export function ThemedToaster() {
  const { resolvedTheme } = useTheme();
  return (
    <Toaster
      position="bottom-right"
      richColors
      duration={3000}
      theme={resolvedTheme === 'dark' ? 'dark' : 'light'}
    />
  );
}
